<script>
import { storeToRefs } from 'pinia';
import ProgressIndicator from './ProgressIndicator.vue';
import SelectProperty from './SelectProperty.vue';
import PersonalDetails from './PersonalDetails.vue';
import Navigator from './Navigator.vue';
import SubmitForm from './SubmitForm.vue';
import SelectSchedule from './SelectSchedule.vue';
import { useVisitStore } from '../../../store/contact/VisitStore';

export default {
    setup() {
        const store = useVisitStore();
        const { setEstateList, getEstateByUrl, getPropertyByUrl } = store;
        const { totalSteps, currentStep } = storeToRefs(store);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        setEstateList((data) => {
            // check if has urlParams type
            if (urlParams.has('type')) {
                if (urlParams.get('type') === 'estates') {
                    if (urlParams.has('object'))
                        getEstateByUrl(urlParams.get('object'));
                }
                if (urlParams.get('type') === 'properties') {
                    if (urlParams.has('object'))
                        getPropertyByUrl(urlParams.get('object'));
                }
            }
        });

        return {
            totalSteps,
            currentStep,
        };
    },
    components: {
        SelectSchedule,
        SelectProperty,
        ProgressIndicator,
        PersonalDetails,
        Navigator,
        SubmitForm,
    },
};
</script>
<template>
    <div class="contact-reserve">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1
                        class="fs-32px fs-40px-xl fw-regular tw-text-darkGreen mb-24px lh-1"
                    >
                        Want to schedule a visit? Tell us more.
                    </h1>
                    <ProgressIndicator></ProgressIndicator>
                    <div class="form-content mt-30px">
                        <div>
                            <span
                                class="d-none d-lg-block steps-count fs-16px tw-text-darkGreen text-uppercase fw-semibold mt-64px-lg"
                            >
                                Step {{ currentStep }} of {{ totalSteps }}</span
                            >
                            <SelectSchedule
                                v-if="currentStep == 1"
                            ></SelectSchedule>
                            <SelectProperty
                                v-if="currentStep == 2"
                            ></SelectProperty>
                            <PersonalDetails
                                v-if="currentStep == 3"
                            ></PersonalDetails>
                        </div>
                    </div>
                </div>
            </div>
            <Navigator v-if="currentStep < totalSteps"></Navigator>
            <SubmitForm v-if="currentStep == totalSteps"></SubmitForm>
        </div>
    </div>
</template>
